import { connect } from 'react-redux';
import DownloadTapsPdf from '../components/DownloadTapsPdf';

@connect(function ({ app: { user } }) {
  return {
    inn: user.getIn(['data', 'inn']),
  };
})
export default class DownloadTapsPdfContainer extends DownloadTapsPdf {}
